<nz-header class="header">
  <div class="header__left">
    <i
      class="toggle-menu"
      nz-icon
      nzType="menu"
      (click)="toggleMenu.emit()"
    ></i>
    <a routerLink="/infor" routerLinkActive="active" class="text-ellipsis">
      <img
        class="avatar"
        src="assets/images/default-avatar.png"
        alt="logo"
        srcset=""
      />
      <span class="username">{{ fullName }}</span>
    </a>
  </div>
  <div class="header__right">
    <div class="search-box">
      <ng-container *ngIf="false">
        <nz-input-group class="search-box__input" [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            nz-input
            placeholder="{{ 'header.search' | transloco }}"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i class="search-box__button" nz-icon nzType="search"></i>
        </ng-template>
      </ng-container>
    </div>
    <div class="action">
      <app-lang-select class="me-3"></app-lang-select>
      <nz-badge class="badge" [nzCount]="notifyCount">
        <a class="badge__box"
          nz-popover
          [(nzPopoverVisible)]="visibleNotify"
          nzPopoverTrigger="click"
          [nzPopoverContent]="notifyTpl"
          nzPopoverPlacement="bottom"
          nzPopoverOverlayClassName="notify-overlay"
          (click)="updateLastSeen()"
        >
          <i class="badge__icon" nz-icon nzType="bell" nzTheme="outline"></i>
        </a>
      </nz-badge>
      <button nz-button nzType="text" nzShape="round" (click)="logout()">
        <i nz-icon nzType="logout" nzTheme="outline"></i>
        {{ 'header.logout' | transloco }}
      </button>
    </div>
  </div>
</nz-header>

<ng-template #notifyTpl>
  <div *ngIf="notifyList.length === 0" class="notify-empty">
    <nz-empty [nzNotFoundContent]="null"></nz-empty>
  </div>
  <ng-container *ngIf="notifyList.length > 0">
    <div *ngFor="let notify of notifyList; index as i;" class="notify d-flex" [class.notify--seen]="notify.seen"
      (click)="detailNotify(notify.type, notify.id, notify.seen)"
    >
      <div class="notify__icon">
        <i nz-icon nzType="solution" nzTheme="outline"></i>
      </div>
      <div class="notify__detail" *ngIf="notify.type !== NotificationTypeEnum.SYSTEM">
        <div class="notify__message">
          <span class="notify__actor">{{ notify.actor }}</span> {{ notify.message }}
        </div>
        <div class="notify__time" [class.notify__time--seen]="notify.seen">
          {{ notify.createdAt | momentDiff:curTime | notifyTime }}
        </div>
      </div>
      <div class="notify__detail" *ngIf="notify.type === NotificationTypeEnum.SYSTEM">
        <div class="notify__message">
          <span class="notify__actor">{{ notify.title }}</span> {{ notify.body }}
        </div>
        <div class="notify__time" [class.notify__time--seen]="notify.seen">
          {{ notify.createdAt | momentDiff:curTime | notifyTime }}
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
